<template>

	<div id="login-container" style="position: absolute;top: 0px; left: 0px;">
		<div id="login-background"></div>
		<main>
			<form @submit.prevent="onSubmit">

				<div class="form-title">
					<img src="/croec/img/4-icone STAGEXPERT.png">
					<h1>Définir votre mot de passe</h1>
					<h6>Ordre des experts-comptables des Pays de la Loire</h6>
				</div>
				<div class="form-content">
					<div class="input_container">
						<ul>
							<li v-bind:class="{ is_valid: contains_eight_characters }">
								8 caractères
							</li>
							<li v-bind:class="{ is_valid: contains_number }">
								Contient un chiffre
							</li>
							<li v-bind:class="{ is_valid: contains_uppercase }">
								Contient une majuscule
							</li>
							<li v-bind:class="{ is_valid: contains_special_character }">
								Contient un caractère spécial
							</li>
						</ul>

						<div
							class="checkmark_container"
							v-bind:class="{ show_checkmark: valid_password }">
							<svg width="50%" height="50%" viewBox="0 0 140 100">
								<path
									class="checkmark"
									v-bind:class="{ checked: valid_password }"
									d="M10,50 l25,40 l95,-70" />
							</svg>
						</div>

						<div style="position: relative; display: inline-block; width: 100%;">
							<input
								:type="showPassword ? 'text' : 'password'"
								@input="checkPassword"
								v-model="password"
								autocomplete="off"
								placeholder="Password"
								style="width: 100%; padding-right: 40px;" />
							<button
								type="button"
								@click="showPassword = !showPassword"
								style="position: absolute; right: 5px; top: 50%; transform: translateY(-50%); border: none; background: transparent; cursor: pointer;">
								<i :class="showPassword ? 'fas fa-eye-slash' : 'fas fa-eye'"></i>
							</button>
						</div>
						<input type="hidden" v-model="token" />

						<hr />

						<div>
							<b-button
								v-if="valid_password"
								type="submit"
								variant="primary"
								>Valider</b-button
							>
						</div>
					</div>
				</div>
				<div class="form-links">
					<a href="/login">Se connecter</a>
				</div>
			</form>
		</main>
		<!-- /CONTENT -->


		<!-- FOOTER -->
		<footer>
			<div class="footer-content">
				<div class="footer-item">
					<img src="/croec/img/1-Logo-STAGEXPERT.png">
					<div class="footer-hr-divider"></div>
				</div>
				<div id="footer-text" class="footer-item">
					<p>Stage expert est la plateforme de suivi du cursus des experts comptables stagiaires. La plateforme les accompagne tout au long du cursus, de l’inscription initiale à la remise de rapport, jusqu’à la remise d’attestation de fin de stage.</p>
				</div>
				<div class="footer-item">
					<p>
						<b>Ordre des Experts-Comptables des Pays de la Loire</b><br><br>
						<b>Siège Social :</b><br>
						2 rue de l’Allier<br>
						44000 Nantes<br><br>

						<b>Adresse Postale :</b>
						14 allée du Haras<br>
						BP 41845 Angers Cedex 01<br><br>

						<b>contact@oecpaysdelaloire.fr</b><br>
						<b>02 41 25 35 45</b>
					</p>
				</div>
				<div class="footer-item">
					<img src="/croec/img/logo-ordec-bleu-MAdEx-RVB.png">
					<div class="footer-hr-divider fhd-right"></div>
					<ul class="footer-social">
						<li>
							<a href="#!">
								<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M12 2.04C6.5 2.04 2 6.53 2 12.06C2 17.06 5.66 21.21 10.44 21.96V14.96H7.9V12.06H10.44V9.85C10.44 7.34 11.93 5.96 14.22 5.96C15.31 5.96 16.45 6.15 16.45 6.15V8.62H15.19C13.95 8.62 13.56 9.39 13.56 10.18V12.06H16.34L15.89 14.96H13.56V21.96A10 10 0 0 0 22 12.06C22 6.53 17.5 2.04 12 2.04Z" /></svg>
							</a>
						</li>
						<li>
							<a href="#!">
								<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M22.46,6C21.69,6.35 20.86,6.58 20,6.69C20.88,6.16 21.56,5.32 21.88,4.31C21.05,4.81 20.13,5.16 19.16,5.36C18.37,4.5 17.26,4 16,4C13.65,4 11.73,5.92 11.73,8.29C11.73,8.63 11.77,8.96 11.84,9.27C8.28,9.09 5.11,7.38 3,4.79C2.63,5.42 2.42,6.16 2.42,6.94C2.42,8.43 3.17,9.75 4.33,10.5C3.62,10.5 2.96,10.3 2.38,10C2.38,10 2.38,10 2.38,10.03C2.38,12.11 3.86,13.85 5.82,14.24C5.46,14.34 5.08,14.39 4.69,14.39C4.42,14.39 4.15,14.36 3.89,14.31C4.43,16 6,17.26 7.89,17.29C6.43,18.45 4.58,19.13 2.56,19.13C2.22,19.13 1.88,19.11 1.54,19.07C3.44,20.29 5.7,21 8.12,21C16,21 20.33,14.46 20.33,8.79C20.33,8.6 20.33,8.42 20.32,8.23C21.16,7.63 21.88,6.87 22.46,6Z" /></svg>
							</a>
						</li>
						<li>
							<a href="#!">
								<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M19 3A2 2 0 0 1 21 5V19A2 2 0 0 1 19 21H5A2 2 0 0 1 3 19V5A2 2 0 0 1 5 3H19M18.5 18.5V13.2A3.26 3.26 0 0 0 15.24 9.94C14.39 9.94 13.4 10.46 12.92 11.24V10.13H10.13V18.5H12.92V13.57C12.92 12.8 13.54 12.17 14.31 12.17A1.4 1.4 0 0 1 15.71 13.57V18.5H18.5M6.88 8.56A1.68 1.68 0 0 0 8.56 6.88C8.56 5.95 7.81 5.19 6.88 5.19A1.69 1.69 0 0 0 5.19 6.88C5.19 7.81 5.95 8.56 6.88 8.56M8.27 18.5V10.13H5.5V18.5H8.27Z" /></svg>
							</a>
						</li>
					</ul>
				</div>
			</div>
			<div class="footer-copyright">
				<p>© 2022 – Stagexpert – Tous droits réservés – Mentions légales</p>
			</div>
		</footer>
	</div>
</template>

<script>
	import password from "../../services/password.js";

	export default {
		data() {
			return {
				token: 0,
				password: null,
				password_length: 0,
				contains_eight_characters: false,
				contains_number: false,
				contains_uppercase: false,
				contains_special_character: false,
				valid_password: false,
				showPassword: false,
			};
		},
		mounted() {
			this.token = this.$route.params.id;
		},
		methods: {
			onSubmit(evt) {
				evt.preventDefault();
				password.password(this.password, this.token).then((res) => {
					this.$router.push({ name: "login" });
				});
			},
			checkPassword() {
				this.password_length = this.password.length;
				const format = /[ !@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/;

				if (this.password_length > 8) {
					this.contains_eight_characters = true;
				} else {
					this.contains_eight_characters = false;
				}

				this.contains_number = /\d/.test(this.password);
				this.contains_uppercase = /[A-Z]/.test(this.password);
				this.contains_special_character = format.test(this.password);

				if (
					this.contains_eight_characters === true &&
					this.contains_special_character === true &&
					this.contains_uppercase === true &&
					this.contains_number === true
				) {
					this.valid_password = true;
				} else {
					this.valid_password = false;
				}
			},
		},
	};
</script>

<style scoped>
	@import '/croec/css/style-formulaires.css';
	@import '/croec/css/style.css';

	@import url('https://fonts.googleapis.com/css?family=Material+Icons');
	@import url('https://fonts.googleapis.com/css?family=Maven+Pro:wght@400;500;600;700;800;900&display=swap');


	/* Password Input --------- */


	input[type="password"] {
		line-height: 1.5;
		display: block;
		color: rgba(136, 152, 170, 1);
		font-weight: 300;
		width: 100%;
		height: calc(2.75rem + 2px);
		padding: 0.625rem 0.75rem;
		border-radius: 0.25rem;
		background-color: #fff;
		transition: border-color 0.4s ease;
		border: 1px solid #cad1d7;
		outline: 0;
	}

	input[type="password"]:focus {
		border-color: rgba(50, 151, 211, 0.45);
	}

	/* Checkmark & Strikethrough --------- */

	.is_valid {
		color: rgba(136, 152, 170, 0.8);
	}
	.is_valid:before {
		width: 100%;
	}

	.checkmark_container {
		border-radius: 50%;
		position: absolute;
		top: -15px;
		right: -15px;
		background: #2ecc71;
		width: 50px;
		height: 50px;
		visibility: hidden;
		opacity: 0;
		display: flex;
		justify-content: center;
		align-items: center;
		transition: opacity 0.4s ease;
	}

	.show_checkmark {
		visibility: visible;
		opacity: 1;
	}

	.checkmark {
		width: 100%;
		height: 100%;
		fill: none;
		stroke: white;
		stroke-width: 15;
		stroke-linecap: round;
		stroke-dasharray: 180;
		stroke-dashoffset: 180;
	}

	.checked {
		animation: draw 0.5s ease forwards;
	}

	@keyframes draw {
		to {
			stroke-dashoffset: 0;
		}
	}
</style>
